import { render } from "./TaskImageAudit.vue?vue&type=template&id=2c315d1e&scoped=true"
import script from "./TaskImageAudit.vue?vue&type=script&lang=js"
export * from "./TaskImageAudit.vue?vue&type=script&lang=js"

import "./TaskImageAudit.vue?vue&type=style&index=0&id=2c315d1e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c315d1e"]])

export default __exports__